import Vue from "vue";
import App from "./App.vue";

document.title = process.env.VUE_APP_PROJECT_NAME || process.env.VUE_APP_PROJECT || "Sensoreal 3";

function loadAdobeFonts(kitId) {
  const href = `https://use.typekit.net/${kitId}.css`

  // Avoid adding the same kit more than once
  if (document.querySelector(`link[href="${href}"]`)) {
    return
  }

  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = href

  document.head.appendChild(link)
}


if (process.env.VUE_APP_ADOBE_KIT_ID) {
  loadAdobeFonts(process.env.VUE_APP_ADOBE_KIT_ID)
}


if (process.env.VUE_APP_SCRIPT_TEMPLATE) {
  require(`../script-templates/${process.env.VUE_APP_SCRIPT_TEMPLATE}.scripts`)();
}

async function loadStyles(name) {
  try {
    await import(`../styles/${name}/index.scss`);
  } catch (error) {
    console.error(`Failed to load styles: ${name}`, error);
  }
}

loadStyles("default");
if (process.env.VUE_APP_STYLE) {
  loadStyles(process.env.VUE_APP_STYLE);
}

// Router + Store + Sync
import router from "./router";
import store from "./store";
import { sync } from "vuex-router-sync";
sync(store, router);

// Font Awesome
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { dom, library } from "@fortawesome/fontawesome-svg-core";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { fad } from "@fortawesome/pro-duotone-svg-icons";
import { faPagelines } from "@fortawesome/free-brands-svg-icons";
dom.watch(); // Allows use of <i class="fas".../> which can be added via coding plain text in the CMS
library.add(fas, far, faPagelines, fad, fal);
Vue.component("fa", FontAwesomeIcon);

Vue.config.productionTip = false;
export const bus = new Vue();

// Global multilingual label helper
Vue.prototype.$label = function (value) {
  // If it's already a plain string, return it
  if (typeof value === "string") {
    return value;
  }

  // If value is missing or not an object, return empty string
  if (!value || typeof value !== "object") {
    return "";
  }

  // Get active language from Vuex
  const activeLanguage = store.state.language.code || "en";

  // Return active language value if it exists
  if (value[activeLanguage]) {
    return value[activeLanguage];
  }

  // Fall back to English
  if (value.en) {
    return value.en;
  }

  // Final fallback: return first available value
  const firstAvailable = Object.values(value).find(Boolean);

  return firstAvailable || "";
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
